import { css } from 'styled-components/native';

export const brandSpecificNavBorderStyle = css`
  border-top-width: 1px;
  border-top-color: #ddd;
  shadow-color: ${Styles.shadowColor};
  shadow-offset: ${Styles.shadowOffset};
  shadow-radius: ${Styles.shadowRadius};
`;
